export const STEP_BUTTON_LABELS = {
  en: {
    back: 'Back',
    start: 'Start a Fundraiser',
  },
  hi: {
    back: 'वापस जाएं',
    start: 'फंडरेज़र शुरू करें',
  },
  ta: {
    back: 'பின்னால் செல்லுங்கள்',
    start: 'நிதி திரட்டலை தொடங்குங்கள்',
  },
  te: {
    back: 'వెనక్కి వెళ్లండి',
    start: 'ఫండ్రైజర్ ప్రారంభించండి',
  }
};
